<template>
    <v-row class="fill-height">
        <v-col>
            <v-sheet height="64">
                <v-toolbar flat>
                    <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                        Hoy
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="prev">
                        <v-icon small>fas fa-chevron-left</v-icon>
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="next">
                        <v-icon small>fas fa-chevron-right</v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="$refs.calendar">
                        {{ $refs.calendar.title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-progress-circular v-if="loading" indeterminate color="primary" size="20" class="mr-4"></v-progress-circular>
                    <v-menu bottom right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                                <span>{{ typeToLabel[type] }}</span>
                                <v-icon right>fas fa-angle-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="type = 'day'">
                                <v-list-item-title>Dia</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'month'">
                                <v-list-item-title>Mes</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
                <VCalendar ref="calendar" v-model="focus" color="primary" :events="events"
                :event-color="getEventColor" :type="type"
                @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange">
                </VCalendar>
                <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
                    <v-card color="grey lighten-4" min-width="350px" flat>
                        <v-toolbar :color="selectedEvent.color" dark>
                            <v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <ul class="attendance-list">
                                <li v-for="(nombre, index) in selectedEvent.details" :key="index">
                                    {{ nombre }}
                                </li>
                            </ul>
                        </v-card-text>
                        <v-card-actions>
                        <v-btn text color="secondary" @click="selectedOpen = false">
                            Cerrar
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-sheet>
        </v-col>
    </v-row>
</template>
<script>
    import AsistenciaDataService from '@/service/empleado/asistenciaDataService';
    import { getDateLocaleNatural } from '@/utils/DateUtil';
import { extractMessage } from '@/helpers/errorHelper';

    export default {
        name: 'CalendarioAsistencia',
        data: () => ({
            focus: '',
            type: 'month',
            typeToLabel: { month: 'Month', week: 'Week', day: 'Day', '4day': '4 Days' },
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            events: [],
            loading: false,
        }),
        mounted () {
            this.$refs.calendar.checkChange()
        },
        methods: {
            viewDay ({ date }) {
                this.focus = date
                this.type = 'day'
            },
            getEventColor (event) {
                return event.color
            },
            setToday () {
                this.focus = ''
            },
            prev () {
                this.$refs.calendar.prev()
            },
            next () {
                this.$refs.calendar.next()
            },
            showEvent ({ nativeEvent, event }) {
                const open = () => {
                    this.selectedEvent = event
                    this.selectedElement = nativeEvent.target
                    setTimeout(() => {
                        this.selectedOpen = true
                    }, 10)
                }

                if (this.selectedOpen) {
                    this.selectedOpen = false
                    setTimeout(open, 10)
                } else {
                    open()
                }
                nativeEvent.stopPropagation()
            },
            updateRange ({ start, end }) {
                this.loading = true
                const startDate = getDateLocaleNatural(start.date)
                const endDate = getDateLocaleNatural(end.date)

                AsistenciaDataService.byRange(startDate, endDate).then(resp => {
                    this.events = this.buildEventsByDay(resp.data || [])
                }).catch(err => {
                    this.$swal.fire({ position: 'top-end', icon: 'error', text: 'Error al cargar asistencias: ' + extractMessage(err), showConfirmButton: false, timer: 3500 });
                }).finally(() => {
                    this.loading = false
                })
            },
            buildEventsByDay (lstAsistencias) {
                const byDay = {}
                lstAsistencias.forEach(asistencia => {
                    const day = asistencia.fechaAsistencia.substring(0, 10)
                    if (!byDay[day]) byDay[day] = []
                    byDay[day].push(asistencia.empleado.nombreCompleto)
                })

                // `details` es un arreglo de nombres, no HTML: el nombre del
                // empleado es texto libre y se renderiza con `{{ }}` para
                // evitar XSS almacenado (antes se interpolaba con `v-html`).
                return Object.keys(byDay).map(day => ({
                    name: `${byDay[day].length} asistencia(s)`,
                    start: new Date(`${day}T00:00:00`),
                    end: new Date(`${day}T23:59:59`),
                    color: 'primary',
                    timed: false,
                    details: byDay[day].slice(),
                }))
            },
        },
    }
</script>
<style scoped>
.attendance-list {
    list-style-type: disc;
    padding-left: 20px;
    margin: 0;
}
</style>
